export function getWorkspaceId(props: {
  configPath?: string
  workspaceName?: string
  endpoint?: string
}) {
  const configPathString = props.configPath ? `${props.configPath}~` : ''
  const workspaceNameString = props.workspaceName
    ? `${props.workspaceName}~`
    : ''
  return `${configPathString}${workspaceNameString}${props.endpoint}`
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Playground/util/getWorkspaceId.ts